export default __webpack_public_path__ + "static/media/access_time.09e82194.svg";